import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

// Prevent browser from restoring scroll position on page reload
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Force scroll to top on page load
window.scrollTo(0, 0);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Ensure the installed app always loads the latest build
async function ensureFreshLoad() {
  try {
    const res = await fetch('/asset-manifest.json', { cache: 'no-store' });
    if (!res.ok) return;
    const manifest = await res.json();
    const entry = (manifest.files && manifest.files['main.js']) || '';
    const prev = localStorage.getItem('asset_main_js');
    if (entry) {
      if (prev && prev !== entry) {
        localStorage.setItem('asset_main_js', entry);
        window.location.reload();
      } else if (!prev) {
        localStorage.setItem('asset_main_js', entry);
      }
    }
  } catch (_) {
    // ignore network errors
  }
}

// Check on first load and whenever app gains focus
ensureFreshLoad();
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    ensureFreshLoad();
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
